import React, {Component} from "react";
import SimpleInput from "../../../../modules/SimpleInput";
import Button from "../../../../modules/commons/Button";
import SimpleModal from "../../../../modules/popup/SimpleModal";
import {Scanner} from "@yudiel/react-qr-scanner";
import Api from "../../../../Services/Api";
import {
    fetchDataAsync,
    FormatCurrencyRupiahTwoDigitsDecimal,
    FormatCurrencyWithoutSymbol
} from "../../../../Services/Utils";
import {HttpStatus} from "../../../common/Constants";

class UnitTab extends Component {
    constructor(props) {
        super(props);
        this.state = {
            scannerVisible: false,
        };
    }

    handleShowScanner = () => {
        this.setState({
            scannerVisible: !this.state.scannerVisible,
        });
    };

    handleScanQR = async (data) => {
        let request = {
            nameCategory: "UNIT",
            encryptBarcode: data[0].rawValue,
            kodeCabang: this.props.kodeCabang,
            trxType: "TRX_OUT",
            trxCode: "FJ"
        };
        console.log(request);
        let response = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_TRANSACTION").findBarcodeUnitMutation,
            menuName: "Delivery Confirmed",
            setError: this.props.setError,
            args: request
        });
        if (response.ok && response.data.status === HttpStatus.SUCCESS && response.data.data !== null) {
            const data = response.data.data;
            if (
                data.kodeCabang === this.props.kodeCabang &&
                data.kodeVariant === this.props.data.kodeVariant &&
                data.noKa === this.props.data.nomorRangka &&
                data.noSin === this.props.data.nomorMesin
            ) {
                const response = await Api.create("NAGAMAS_TRANSACTION").updateDeliveryStatus(
                    this.props.id
                );
                if (response.ok) {
                    this.props.onUpdateStatus();
                }
                this.handleShowScanner();
            }
        }
        if(response.data.data === 'barcode not found'){
            this.props.setError({
                menuName: "Delivery Confirmed",
                errorMessage: response.data.data
            })
        }
    };

    render() {
        return (
            <div>
                {!this.props.viewOnly && (
                    <Button
                        type="button"
                        className="btn"
                        style={{borderRadius: "50%"}}
                        onClick={this.handleShowScanner}
                    >
            <span>
              <i className="fa fa-qrcode"></i>
            </span>
                    </Button>
                )}
                <div className="grid grid-2x grid-mobile-none gap-15px">
                    <div id="grid-1">
                        <SimpleInput
                            id="input_text_nilai_dibayar"
                            name="nilaiDibayar"
                            label="NILAI YANG HARUS DIBAYAR"
                            readOnly
                            value={FormatCurrencyRupiahTwoDigitsDecimal({number:this.props.data?.priceNominal})}
                        />
                        <SimpleInput
                            id="input_text_nama_pembeli"
                            name="namaPembeli"
                            label="Nama Pembeli"
                            readOnly
                            value={this.props.data?.namaPembeli}
                        />
                        <SimpleInput
                            id="input_text_kode_varian"
                            name="kodeVarian"
                            label="KODE VARIAN"
                            readOnly
                            value={this.props.data?.kodeVariant}
                        />
                        <SimpleInput
                            id="input_text_nama_varian"
                            name="namaVarian"
                            label="NAMA VARIAN"
                            readOnly
                            value={this.props.data?.namaVariant}
                        />
                    </div>
                    <div id="grid-2">
                        <SimpleInput
                            id="input_text_status"
                            name="status"
                            label="STATUS"
                            readOnly
                            value={this.props.data?.unitDeliveryStatus}
                        />
                        <SimpleInput
                            id="input_text_warna"
                            name="warna"
                            label="WARNA"
                            readOnly
                            value={this.props.data?.namaWarnaKomersil}
                        />
                        <SimpleInput
                            id="input_text_no_rangka"
                            name="noRangka"
                            label="NO RANGKA"
                            readOnly
                            value={this.props.data?.nomorRangka}
                        />
                        <SimpleInput
                            id="input_text_no_mesin"
                            name="noMesin"
                            label="NO MESIN"
                            readOnly
                            value={this.props.data?.nomorMesin}
                        />
                    </div>
                </div>
                {this.state.scannerVisible && (
                    <SimpleModal
                        title={"Scan QR Here"}
                        styles={{width: "40%"}}
                        visible={this.state.scannerVisible}
                        onClickClose={this.handleShowScanner}
                        content={
                            <Scanner
                                onScan={this.handleScanQR}
                                constraints={{
                                    height: {ideal: 720},
                                    video: {
                                        facingMode: { exact: "environment" },
                                        height: { ideal: 720 }
                                    },
                                }}
                            />
                        }
                    />
                )}
            </div>
        );
    }
}

export default UnitTab;
